import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals.ts';

// Add simple platform classes for CSS tuning (iOS vs Android)
(() => {
  const ua = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);
  const root = document.documentElement;

  if (isIOS) root.classList.add('platform-ios');
  else if (isAndroid) root.classList.add('platform-android');
  else root.classList.add('platform-web');
})();

// Force scroll to top on page load/refresh
if (window.history.scrollRestoration) {
  window.history.scrollRestoration = 'manual';
}

window.onload = function() {
  window.scrollTo(0, 0);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 